import type { Locale } from '@/i18n/types'

function localeTag(locale: Locale): string {
  return locale === 'de' ? 'de-DE' : 'en-US'
}

export function formatCompactWithUnit(value: number, locale: Locale, unit: string): string {
  if (value >= 1_000_000) {
    return `${new Intl.NumberFormat(localeTag(locale), {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value / 1_000_000)}M ${unit}`
  }

  if (value >= 1_000) {
    return `${new Intl.NumberFormat(localeTag(locale), {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value / 1_000)}K ${unit}`
  }

  return `${new Intl.NumberFormat(localeTag(locale)).format(value)} ${unit}`
}

export function formatCompactNumber(value: number, locale: Locale): string {
  if (value >= 1_000_000) {
    return `${new Intl.NumberFormat(localeTag(locale), {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value / 1_000_000)}M`
  }

  if (value >= 1_000) {
    return `${new Intl.NumberFormat(localeTag(locale), {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value / 1_000)}K`
  }

  return new Intl.NumberFormat(localeTag(locale)).format(value)
}

export function formatCurrencyUsd(value: number, locale: Locale, fractionDigits = 4): string {
  return new Intl.NumberFormat(localeTag(locale), {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)
}
